module.exports = __webpack_public_path__ + "img/caja5.384cfab9.png";